module.exports = __webpack_public_path__ + "components/resort-guide/item/static/icon-vertical-arrow--black-1ae190ed39440c09fe1026d41812cbef.svg";